import { render, staticRenderFns } from "./u-icon.vue?vue&type=template&id=39457a6a&scoped=true&"
import script from "./u-icon.vue?vue&type=script&lang=js&"
export * from "./u-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39457a6a",
  null
  
)

export default component.exports